/* Reuse Empire's form, variant state and add-to-cart handler. */
(function () {
  'use strict';
  function initialize() {
    var wrapper = document.querySelector('[data-product-wrapper]');
    var bar = document.querySelector('[data-sticky-purchase]');
    if (!wrapper || !bar || bar.dataset.initialized) return;
    var button = wrapper.querySelector('[data-product-atc]');
    var price = wrapper.querySelector('[data-price]');
    var proxy = bar.querySelector('[data-sticky-atc]');
    if (!button || !price || !proxy || !('IntersectionObserver' in window)) return;
    bar.dataset.initialized = 'true';
    var visible = true;
    var afterForm = bar.hasAttribute('data-sticky-after-form');
    var passed = false;
    var mobile = window.matchMedia('(max-width: 719px)');
    var scrollFrame = null;
    function synchronize() {
      proxy.disabled = button.disabled;
      var processing = button.classList.contains('processing');
      proxy.textContent = processing ? bar.dataset.loadingLabel : button.textContent.trim();
      proxy.setAttribute('aria-busy', processing ? 'true' : 'false');
      var currentPrice = wrapper.querySelector('[data-price]');
      bar.querySelector('[data-sticky-price]').textContent = currentPrice ? (currentPrice.innerText || currentPrice.textContent).trim() : '';
      var variantLabel = bar.querySelector('[data-sticky-variant]');
      var selected = wrapper.querySelector('[name="id"]');
      if (variantLabel && selected && selected.options) {
        var option = selected.options[selected.selectedIndex];
        variantLabel.textContent = option ? option.dataset.variantTitle || '' : '';
      }
      var show = mobile.matches && !visible && (!afterForm || passed);
      bar.hidden = !show;
      document.body.classList.toggle('zt-sticky-active', show);
      document.body.style.setProperty('--zt-sticky-height', show ? bar.offsetHeight + 'px' : '0px');
    }
    proxy.addEventListener('click', function () {
      if (!button.disabled) button.click();
    });
    var intersection = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      passed = entries[0].boundingClientRect.bottom <= 0;
      synchronize();
    });
    intersection.observe(button);
    // A fast scroll can jump from below to above the viewport without changing
    // intersection state. Recheck position once per frame for those jumps.
    function schedulePositionCheck() {
      if (scrollFrame !== null) return;
      scrollFrame = requestAnimationFrame(function () {
        scrollFrame = null;
        var bounds = button.getBoundingClientRect();
        visible = bounds.bottom > 0 && bounds.top < window.innerHeight;
        passed = bounds.bottom <= 0;
        synchronize();
      });
    }
    window.addEventListener('scroll', schedulePositionCheck, { passive: true });
    window.addEventListener('resize', schedulePositionCheck);
    var mutations = new MutationObserver(synchronize);
    mutations.observe(wrapper, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    wrapper.addEventListener('change', synchronize);
    mobile.addEventListener('change', synchronize);
    var sizeObserver = 'ResizeObserver' in window ? new ResizeObserver(synchronize) : null;
    if (sizeObserver) sizeObserver.observe(bar);
    synchronize();
    function unload(event) {
      if (!event.target.contains(wrapper)) return;
      intersection.disconnect();
      mutations.disconnect();
      if (sizeObserver) sizeObserver.disconnect();
      window.removeEventListener('scroll', schedulePositionCheck);
      window.removeEventListener('resize', schedulePositionCheck);
      if (scrollFrame !== null) cancelAnimationFrame(scrollFrame);
      wrapper.removeEventListener('change', synchronize);
      mobile.removeEventListener('change', synchronize);
      document.body.classList.remove('zt-sticky-active');
      document.body.style.removeProperty('--zt-sticky-height');
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
}());
